/* src/app/components/payroll/timesheets/timesheet-consumer-list/timesheet-consumer-list.component.css */
.line1 {
  display: flex;
  justify-content: space-between;
}
.filters {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.ant-select-selector {
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
}
.check-filter {
  width: 100%;
  height: 32px;
  padding: 0 11px;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  color: rgba(0, 0, 0, 0.85);
}
:host ::ng-deep .accordion-body {
  gap: 12px !important;
}
.message {
  margin-bottom: 0px;
  margin-top: 16px;
  margin-left: 8px;
  font-weight: 500;
}
:host ::ng-deep .in-process th {
  width: 11% !important;
}
.ant-form-item {
  padding-bottom: 0 !important;
  margin-bottom: 0 !important;
}
:host ::ng-deep .in-process td.check-box .ppl-row-disabled {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: bottom;
  width: var(--p-checkbox-width, 20px);
  height: var(--p-checkbox-height, 20px);
  border: 1px solid var(--p-checkbox-border-color, #d4d4d8);
  border-radius: var(--p-checkbox-border-radius, 4px);
  background: var(--p-checkbox-disabled-background, #e9ecef);
  cursor: not-allowed;
}
:host ::ng-deep .in-process td.check-box .ppl-row-disabled .fa-lock {
  display: none;
}
.bulk-action-buttons {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin-bottom: 8px;
}
.timesheet-action-buttons {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}
/*# sourceMappingURL=timesheet-consumer-list.component-DERCV25J.css.map */
